<template>
  <upModel
    :show="value"
    :autoHeight="true"
    class="common-open-app-model"
    @close="maskClose"
    v-stat.show="'引导打开APP弹窗'"
  >
    <div v-if="value" class="common-open-app-model-context">
      <div class="common-open-app-model-cap">继续浏览</div>
      <div>
        <div class="common-open-app-model-item">
          <img
            :src="
              'https://ossimg.xinli001.com/20200309/9c00bc9481c1ddf25fddcc94f2f451ae.png'
                | imgZip(90)
            "
            class="common-open-app-model-image"
          />
          <div class="common-open-app-model-content">
            <p class="common-open-app-model-title">壹心理</p>
            <p class="common-open-app-model-desc">世界和我爱着你</p>
          </div>
          <div
            class="common-open-app-model-btn"
            v-stat="'引导打开APP弹窗-打开'"
            v-open-app="{
              url: toApp
            }"
          >
            打开
          </div>
        </div>
        <div class="common-open-app-model-item">
          <img
            :src="
              'https://ossimg.xinli001.com/20210128/126b50c3c3aba48b332412d19be00fe0.png'
                | imgZip(90)
            "
            class="common-open-app-model-image"
          />
          <div class="common-open-app-model-content">
            <p class="common-open-app-model-title">浏览器</p>
          </div>
          <div
            class="common-open-app-model-btn grey"
            @click="onClose"
            v-stat="'引导打开APP弹窗-继续'"
          >
            继续
          </div>
        </div>
      </div>
    </div>
  </upModel>
</template>

<script>
import upModel from 'app/frontend-lib/component/vue/upModel/upModel.vue'
// import { Base64 } from 'js-base64'
import { getCookie, setCookie } from 'app/frontend-lib/tools/cookies'
const isServer = process.env.VUE_ENV === 'server'
const cookieKey = 'consult_open_app_model_disable'
// http://112.124.122.87:8084/index.php?m=story&f=view&storyID=2128
export default {
  components: {
    upModel
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    link: {
      type: String,
      default() {
        return isServer ? '' : window.location.href
      }
    }
  },
  created() {
    if (!isServer) {
      const {
        isWechat,
        isYixinliApp,
        isZiXunApp,
        isCeShiApp,
        isZiXunShiApp,
        isPc
      } = this.$platform
      const { cid, channel_id } = this.$route.query
      const isApp = isYixinliApp || isZiXunApp || isCeShiApp || isZiXunShiApp
      const hasChannelParams = cid || channel_id
      const modalAllowShow = getCookie(cookieKey) === undefined
      const isMeiTuanApp = /com.meituan.imeituan/i.test(navigator.userAgent)
      if (
        !isWechat &&
        !isApp &&
        !hasChannelParams &&
        !isPc &&
        !this.$getMP &&
        !isMeiTuanApp &&
        modalAllowShow
      ) {
        this.$emit('input', true)
      }
    }
  },
  methods: {
    onClose() {
      setCookie({
        key: cookieKey,
        value: 1,
        timeMinSec: 24 * 60 * 60 * 1000,
        domain: location.host.includes(':') ? location.hostname : 'xinli001.com'
      })
      this.$emit('input', false)
    },
    maskClose() {
      this.eventStat('引导打开APP弹窗-蒙层')
      this.onClose()
    }
  },
  computed: {
    toApp() {
      if (this.$isServer) return
      const { link } = this
      return link
    }
  }
}
</script>

<style lang="scss">
.common-open-app-model {
  &-context {
    padding: 30px 40px;
  }
  &-cap {
    font-size: 28px;
    color: #121212;
  }

  &-item {
    display: flex;
    padding: 32px 0;
    height: 88px;
    align-items: center;
    position: relative;

    &:not(:nth-child(1)):before {
      display: block;
      content: ' ';
      position: absolute;
      top: -50%;
      right: -50%;
      bottom: -50%;
      left: -50%;
      pointer-events: none;
      -webkit-transform: scale(0.5);
      transform: scale(0.5);
      border-top: 1px solid #d3d3d3;
    }
  }

  &-image {
    width: 88px;
    height: 88px;
    margin-right: 20px;
  }

  &-title {
    font-size: 32px;
    color: #121212;
    font-weight: bold;
  }
  &-desc {
    font-size: 24px;
    color: #121212;
  }

  &-content {
    flex: 1;
  }

  &-btn {
    font-size: 32px;
    line-height: 76px;
    text-align: center;
    margin-left: auto;
    width: 180px;
    height: 76px;
    background: #718aff;
    border-radius: 12px;
    color: #fff;
    &.grey {
      color: #646464;
      background-color: hsla(0, 0%, 92.2%, 0.7);
    }
  }
}
</style>
